import dynamic from "next/dynamic";

// SSRだとエラーになるので、dynamicにした
export default dynamic(() => import("./PointPlanForm").then((mod) => mod.PointPlanForm), {
  loading: () => null,
  ssr: false,
});
